
import Button from '@/ui-kit/components/button';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import ListingOwnerContactsBookViewingDateCarousel from './date-carousel';
import ListingOwnerContactsBookViewingTimeSlots from './time-slots';
import BookViewingAvailabilitiesHelper from './helpers/availabilitiesHelper';
import { BookViewingCarouselPropsEventType } from '../owner-contacts/enums';
import { ListingPageEvent } from '@/constants/AnalyticEvents';
import { LISTING_ORIGIN_TYPES } from '@/constants';
import { BOOK_VIEWING_EVENT_LABEL } from './constants';

const MIN_ITEMS_GAP_BEFORE_LOAD = 3;
const DEFAULT_ITEMS_VISIBLE_AMOUNT = 2;
const DEFAULT_ACTIVE_INDEX = 0;

export default {
  name: 'ListingBookViewing',
  components: {
    Button,
    Typography,
    ListingOwnerContactsBookViewingDateCarousel,
    ListingOwnerContactsBookViewingTimeSlots,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isUserTitleHolder: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      StyleColorSchemeType,
      TypographyType,
      BookViewingCarouselPropsEventType,
      availabilities: null,
      activeDayIndex: DEFAULT_ACTIVE_INDEX,
      activeTimeIndex: DEFAULT_ACTIVE_INDEX,
      itemsVisible: DEFAULT_ITEMS_VISIBLE_AMOUNT,
    };
  },
  computed: {
    availabilitiesIntervals() {
      return this.availabilities
        ? [...this.availabilities.days.values()]
        : [];
    },
    availableDays() {
      return this.availabilitiesIntervals.map(({ value }) => value);
    },
    availableTimes() {
      return this.availabilitiesIntervals[this.activeDayIndex]?.timeSlots;
    },
    trackEventAttributes() {
      return {
        listingId: this.id,
        listingType: LISTING_ORIGIN_TYPES.Bode,
        eventlabel: BOOK_VIEWING_EVENT_LABEL,
        email: this.user.email || '',
        authenticated: this.user.isAuthenticated,
      };
    },
    isSubmitDisabled() {
      return !this.availableDays.length || this.isLoading || this.isUserTitleHolder;
    },
    user() {
      return this.$store.state.user.userData;
    },
  },
  async mounted() {
    this.availabilities = await this.loadAvailabilities();
  },
  methods: {
    handleDaySelectItem(index) {
      this.activeDayIndex = index;
      this.activeTimeIndex = DEFAULT_ACTIVE_INDEX;
      this.$track(ListingPageEvent.BookViewingDateSelected, this.trackEventAttributes);
    },
    handleTimeSelectItem(index) {
      this.activeTimeIndex = index;
      this.$track(ListingPageEvent.BookViewingTimeSelected, this.trackEventAttributes);
    },
    handleItemsAmountChange(itemsVisible) {
      this.itemsVisible = itemsVisible;
    },
    async handleDayActiveIndexChange(index) {
      if (this.availableDays.length - index <= MIN_ITEMS_GAP_BEFORE_LOAD) {
        const availabilities = await this.loadAvailabilities(this.availabilities.to);

        this.availabilities = BookViewingAvailabilitiesHelper.mergeAvailabilities(
          this.availabilities,
          availabilities,
        );
      }
    },
    loadAvailabilities(fromDate) {
      return BookViewingAvailabilitiesHelper.fetchListingAvailability(this.id, fromDate);
    },
    handleSubmitRequest() {
      const day = this.availableDays[this.activeDayIndex];
      const time = this.availableTimes[this.activeTimeIndex];

      this.$emit('bookViewing', { day, time });
    },
  },
};
